export default __webpack_public_path__ + "static/media/icon-notif-connexion.71edecb9.svg";